import React from 'react';
import { gql } from '@apollo/client';
import { DeleteModalController, DeleteModalControllerProps } from './DeleteModal.controller';
import { useRemoveSocialProfileMutation } from '../../../../models/graphql';

export type DeleteModalApolloProps = Omit<
  DeleteModalControllerProps,
  'removeSocialProfileMutation' | 'loading' | 'deleteError'
> & {
  //
};

gql`
  mutation RemoveSocialProfile($socialProfileId: ID!) {
    removeSocialProfile(socialProfileId: $socialProfileId)
  }
`;

export const DeleteModalApollo = (props: DeleteModalApolloProps): JSX.Element => {
  const [removeSocialProfileMutation, { loading }] = useRemoveSocialProfileMutation();

  const args: DeleteModalControllerProps = {
    ...props,
    loading,
    removeSocialProfileMutation
  };

  return <DeleteModalController {...args} />;
};
